import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for R5M8 (客戶寄庫交運單沖銷)
// ============================================================

export interface ReverseCandidate {
  fm160_01: string;       // 交運單號
  fm160_11: string;       // 交運日期 (YYYY-MM-DD)
  fm160_12: string;       // 倉位
  fm160_22: string;       // 客戶代碼
  customer_name: string;  // 客戶名稱 (F105 lookup)
  total_qty: string;      // 合計數量
  total_amt: string;      // 合計金額
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const r5m8Api = {
  /** Query consignment delivery order candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/r5m8/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected consignment delivery orders */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/r5m8/reverse', { items });
    return res.data;
  },
};
